import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const parseResumes = (body) =>
  swRequest({
    path: "/api/resumes/parse",
    method: "POST",
    body,
  });
